import styled from '@emotion/styled';

export default styled('div')({
  display: 'inline-block',
  flex: '0 0 2.4rem',
  marginLeft: '.8rem',
});
